/* ═══════════════════════════════════════════════════════
   NYC Suite — Calendar Client (browser → calendarProxy callable)
   ═══════════════════════════════════════════════════════
   Thin wrapper over the `calendarProxy` Firebase callable.
   The Google OAuth credentials stay server-side (Secret Manager) — the
   browser never sees them. Mirrors the callClaude pattern in lib/ai.js.
*/
import { callable } from "../firebase.js";

export async function callCalendar(action, payload = {}) {
  const fn = callable("calendarProxy");
  let res;
  try {
    res = await fn({ action, ...payload });
  } catch (e) {
    // Firebase HttpsError → surface a clean message (e.code is available too).
    throw new Error(e?.message || `Calendar request failed (${action})`);
  }
  return res?.data;
}
